import { ViewModel,View } from "binder"
import  { BenefitSalesView } from "./benefitSales-view"
import { ServerConnection } from "src/server/serverConnection";
import { downloadFile } from "src/uicomponents/components/utilities";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";

export class BenefitSalesViewModel extends WindowViewModel{
    public getTitle(): string {
        return 'گزارش سود';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    GetDefaultView(): View <ViewModel> {
        return new BenefitSalesView();
    }
    public getTypeId(): string {
        return "VM-146A4DE6-63CE-45F8-B291-AA5F66DE612A"
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set from(v: moment.Moment) { 
        let v2 = v.clone().local().hour(0).minute(0).second(0).millisecond(0)
        this._from = v2; 
    } public get from(): moment.Moment { return this._from;} private _from: moment.Moment;
    public set until(v: moment.Moment) { 
        let v2 = v.clone().local().hour(23).minute(59).second(59).millisecond(999)
        this._until = v2; 
    } public get until(): moment.Moment { return this._until;} private _until: moment.Moment;
    
    async download(){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer("/Complex/ReportServices/BenefitOfProducts", {
                FromDateTime : this.from,
                UntilDateTime : this.until
            });
            downloadFile(result.ExcelFile,'گزارش سود.xlsx');
            if(result.IsSuccessful == true){
                await this.messageBoxConfirmSuccess("گزارش با موفقیت دانلود شد.","گزارش سود");
            }

        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
}
